// extracted by mini-css-extract-plugin
module.exports = {"spacer":"home_spacer__3MOp4","appWrapper":"home_appWrapper__3Fes-","wrapper":"home_wrapper__2U3DQ","paper":"home_paper__2FPJi","appContainer":"home_appContainer__39oOf"};